export enum SequenceState {
  ACTIVE = "-active",
  HIDE = "-hide",
  DISABLE = "-disable",
}
